import { useLocale } from 'next-intl';

import { ELanguage } from '@/enums/language.enum';
import type { ILocalization } from '@/interfaces/common.interface';

export const useLocalizedProperty = () => {
  const locale: ELanguage = useLocale() as ELanguage;
  const getLocalizedProperty = (item?: ILocalization): string => {
    return item?.[locale] || item?.[ELanguage.ENGLISH] || '';
  };

  return getLocalizedProperty;
};
